import { z } from 'zod';

export const NOTIFICATION_TYPES = [
  'request_match',
  'application_received',
  'application_accepted',
  'reminder_24h',
  'reminder_2h',
] as const;
export type NotificationType = (typeof NOTIFICATION_TYPES)[number];

/** A row from the notifications audit log (the recipient's own). */
export interface AppNotification {
  readonly id: string;
  readonly type: NotificationType;
  readonly title: string;
  readonly body: string;
  readonly relatedRequestId: string | null;
  readonly createdAt: string;
  readonly readAt: string | null;
}

const rowSchema = z.object({
  id: z.string(),
  type: z.enum(NOTIFICATION_TYPES),
  title: z.string(),
  body: z.string(),
  related_request_id: z.string().nullable(),
  created_at: z.string(),
  read_at: z.string().nullable(),
});

export function mapNotification(row: unknown): AppNotification {
  const r = rowSchema.parse(row);
  return {
    id: r.id,
    type: r.type,
    title: r.title,
    body: r.body,
    relatedRequestId: r.related_request_id,
    createdAt: r.created_at,
    readAt: r.read_at,
  };
}
